export const facilityReservationHeaders = [
  {
    text: "First Name",
    value: "customer_first_name"
  },
  {
    text: "Last Name",
    value: "customer_last_name"
  },
  {
    text: "Phone",
    value: "customer_phone"
  },
  {
    text: "Email",
    value: "customer_email"
  },
  {
    text: "Type",
    value: "status"
  },
  {
    text: "Quoted Price",
    value: "quoted_price"
  },
  {
    text: "Move In Date",
    value: "move_in_date"
  },
  {
    text: "Promotion Offered",
    value: "promotion.text"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions",
    width: "1%"
  }
];
